import { c as _c } from "react/compiler-runtime";
import { Modal } from '@7f-ui/components/modal/modal';
import { useToast } from '@7f-ui/components/toast/toast-provider';
import type { ProductType } from '@data-access/graphql/schema.types';
import { trackChangeWishlist, trackOpenChangeWishlist } from '@feat/feat-tracking/wishlist';
import { Plus } from '@phosphor-icons/react/dist/ssr';
import { toastDuration as duration } from '../constants';
import { useWishlistMutation } from '../hooks/use-wishlist-mutation';
import { useWishlistName } from '../hooks/use-wishlist-name';
import { WishlistItem } from './wishlist-item';
type Wishlist = {
  id: string;
  items: {
    id: string;
    image: string;
    productId: string;
    productName: string;
    productType: ProductType;
    publicProductId: number;
    locationName: string;
    available?: boolean | null;
    stars?: number | null;
    duration?: number | null;
  }[];
  name: string;
};
type ChangeWishlistModalProps = {
  isOpen: boolean;
  wishlists: Wishlist[] | undefined;
  wishlistItemId?: string;
  onToggleChangeModal: (open: boolean) => void;
  onOpenCreateModal: () => void;
  onChangeLastUsedWishlist: (id: string | null) => void;
};
export function ChangeWishlistModal(t0) {
  const $ = _c(28);
  const {
    isOpen,
    wishlists,
    wishlistItemId,
    onOpenCreateModal,
    onToggleChangeModal,
    onChangeLastUsedWishlist
  } = t0;
  const toast = useToast();
  const {
    switchWishlists
  } = useWishlistMutation();
  const {
    getWishlistName
  } = useWishlistName();
  let t1;
  if ($[0] !== getWishlistName || $[1] !== onChangeLastUsedWishlist || $[2] !== onToggleChangeModal || $[3] !== switchWishlists || $[4] !== toast || $[5] !== wishlistItemId) {
    t1 = async wishlist => {
      if (!wishlistItemId) {
        return;
      }
      await switchWishlists({
        wishlistItemId,
        newWishlistId: wishlist.id
      });
      onToggleChangeModal(false);
      onChangeLastUsedWishlist(wishlist.id);
      trackChangeWishlist();
      const listName = getWishlistName(wishlist.name);
      toast({
        type: "success",
        message: <>{"Gespeichert in "}<strong>{listName}</strong></>,
        actionLabel: "\xC4NDERN",
        actionOnClick: () => {
          onToggleChangeModal(true);
          trackOpenChangeWishlist();
        }
      }, {
        toastOptions: {
          duration
        }
      });
    };
    $[0] = getWishlistName;
    $[1] = onChangeLastUsedWishlist;
    $[2] = onToggleChangeModal;
    $[3] = switchWishlists;
    $[4] = toast;
    $[5] = wishlistItemId;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const handleSwitch = t1;
  let t2;
  if ($[7] !== onToggleChangeModal) {
    t2 = () => onToggleChangeModal(false);
    $[7] = onToggleChangeModal;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== onToggleChangeModal) {
    t3 = <Modal.Header onClose={() => onToggleChangeModal(false)}>Wunschlisten</Modal.Header>;
    $[9] = onToggleChangeModal;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== handleSwitch || $[12] !== wishlists) {
    t4 = wishlists?.map(wishlist_0 => <li key={wishlist_0.id}><button onClick={() => handleSwitch(wishlist_0)} className="mb-6 w-full text-left"><WishlistItem name={wishlist_0.name} items={wishlist_0.items} id={wishlist_0.id} /></button></li>);
    $[11] = handleSwitch;
    $[12] = wishlists;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t4) {
    t5 = <Modal.Content><ul>{t4}</ul></Modal.Content>;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== onOpenCreateModal || $[17] !== onToggleChangeModal) {
    t6 = () => {
      onToggleChangeModal(false);
      onOpenCreateModal();
    };
    $[16] = onOpenCreateModal;
    $[17] = onToggleChangeModal;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className="flex items-center gap-2"><Plus size={20} />Neue Liste</p>;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t6) {
    t8 = <Modal.Footer><Modal.Footer.Actions><Modal.Footer.Button onClick={t6}>{t7}</Modal.Footer.Button></Modal.Footer.Actions></Modal.Footer>;
    $[20] = t6;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== isOpen || $[23] !== t2 || $[24] !== t3 || $[25] !== t5 || $[26] !== t8) {
    t9 = <Modal isOpen={isOpen} onClose={t2} size="small">{t3}{t5}{t8}</Modal>;
    $[22] = isOpen;
    $[23] = t2;
    $[24] = t3;
    $[25] = t5;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
}